const config = {
	persistence: {
		type: "default",		
	}
};

export default config;